export default __webpack_public_path__ + "static/media/urlAttachment.5022861a.svg";